export default __webpack_public_path__ + "static/media/headLogo.e232b62e.svg";